export class OrderPriorityDto {
    OrderId: number;
    PriorityId: string;
    
    constructor() {

    }
}
